import { gql } from "@apollo/client";
export default gql`
  mutation DeleteStudy($input: DeleteStudyInput!) {
    deleteStudy(input: $input) {
      sucess
    }
  }
`;
